export const getters = {
  getIssues($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getIssueById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getMyIssues($state, $getters) {
    return $getters.getIssues.filter(issue => {
      const { is_member: isMember } = issue;
      return isMember;
    });
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getIssue: $state => id => {
    const issue = $state.records[id];
    return issue || {};
  },
};
